import { RetroCreditOrderDetails, RetroCreditState } from '@/store/retro-credit';

import { Restaurant, SubmitRetroCreditRequest, SubmitRetroCreditException, SubmitRetroCreditError, RetroCreditValidationErrorCode } from '@/models';
import { MUTATIONS } from '@/store/retro-credit';
import { ApiService } from '../api/api.service';
import { AxiosError } from 'axios';
import { sleep } from '@/helpers';

export interface RetroCreditService {
  submit(request: SubmitRetroCreditRequest): Promise<any>;
  reset(): void;

  setInProgress(inProgress: boolean): void;
  setState(state: RetroCreditState): void;
  setRetaurants(restaurants: Restaurant[]): void;
  setSelectedRestaurant(restaurant: Restaurant | null): void;
  setOrderDetails(details: RetroCreditOrderDetails | null): void;
}

export class AppRetroCreditService extends ApiService implements RetroCreditService {

  async submit(request: SubmitRetroCreditRequest) {
    return this.httpClient.post(`/retrocredit/v2/transactions`, request).catch((e: AxiosError) => {
      if (e.response && e.response.status == 400) {
        const error = e.response.data as SubmitRetroCreditError | null;

        throw new SubmitRetroCreditException(error?.validationErrors || []);
      }

      if (e.response && e.response.status == 409) {
        throw new SubmitRetroCreditException([{ errorCode: RetroCreditValidationErrorCode.DuplicateRequest }]);
      }

      throw e;
    });
  }

  reset() {
    this.setState(RetroCreditState.Landing);
    this.setRetaurants([]);
    this.setSelectedRestaurant(null);
    this.setOrderDetails(null);
  }

  setInProgress(inProgress: boolean) {
    this.store.commit(MUTATIONS.SET_IN_PROGRESS, inProgress);
  }

  setState(state: RetroCreditState): void {
    this.store.commit(MUTATIONS.SET_STATE, state);
  }

  setRetaurants(restaurants: Restaurant[]): void {
    this.store.commit(MUTATIONS.SET_RESTAURANTS, restaurants);
  }

  setSelectedRestaurant(restaurant: Restaurant | null): void {
    this.store.commit(MUTATIONS.SET_SELECTED_RESTAURANT, restaurant);
  }

  setOrderDetails(details: RetroCreditOrderDetails | null): void {
    this.store.commit(MUTATIONS.SET_DETAILS, details);
  }
}
